import { FC } from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import textsData from '@/textData/ResetPasswordTexts.json'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import lockIcon from '@/assets/rentmote-lock-icon.png'
import { ResetPasswordForm } from '../organism'
import { pathURL } from '@/components/constants/urls'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
`
const StyledText = styled.div`
  text-align: center;
  width: 300px;
  & > h1 {
    color: black;
  }
  & > p {
    word-wrap: normal;
  }
`
export const ResetPasswordTemplate: FC = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.resetPassword : textsData.en.resetPassword

  return (
    <Wrapper>
      <div>
        <img src={lockIcon} width="128" alt="" />
      </div>
      <StyledText>
        <h1>{texts.title}</h1>
        <p>
          {texts.paragraph}
        </p>
      </StyledText>
      
        <ResetPasswordForm />
      
      <div>
        <p>{texts.back.text} <Link to={`/${pathURL.LOGIN}`}>{texts.back.linkText}</Link></p>
      </div>
    </Wrapper>  
  )
}
